import script from "./zuoyedantiao.vue?vue&type=script&setup=true&lang=js"
export * from "./zuoyedantiao.vue?vue&type=script&setup=true&lang=js"

import "./zuoyedantiao.vue?vue&type=style&index=0&id=3370def0&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3370def0"]])

export default __exports__